// extracted by mini-css-extract-plugin
module.exports = {"internalVersionTag":"InternalVersionTag_internalVersionTag__ul_i_"};